import React from 'react';

// Numbered vertical timeline for "Tips for best results" sections.
// Pass `tips` as an array of { label, tip }.
export default function TipsList({ tips }) {
  return (
    <div className="tips-list">
      {tips.map((t, i) => (
        <div className="tips-item" key={t.label}>
          <div className="tips-badge">{String(i + 1).padStart(2, '0')}</div>
          <div className="tips-body">
            <h3 className="tips-title">{t.label}</h3>
            <p className="tips-desc">{t.tip}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
